import { createUseStyles } from "react-jss";

export const useStyle = createUseStyles({
  notificationIcon: {
    cursor: 'pointer',
    margin: '0 4px',
    marginTop: 4,
    color: '#000000',
  },
  settingPage: {
    maxHeight: '640px',
    overflowY: 'auto',
    width: '440px',
  },
  checkBoxStyle: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    paddingTop: '14px',
  },
  reciveTextStyle: {
    color: '#111',
    fontSize: '10px',
    fontWeight: 600,
  },
  notificationTitle: {
    '& .ant-popover-title': {
      padding: '12px 16px',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#111',
    fontSize: '16px',
    fontWeight: '600',
  },
  settingDivider: {
    '& .ant-divider': {
      margin: '18px 0px',
    },
  },
  showUnreadSwitch: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
  },
  avatarStyle: {
    '& .ant-list-item-meta-avatar': {
      marginRight: '10px',
    },
  },
  timeLine: {
    '&:hover': {
      backgroundColor: '#f0f0f0 !important',
      cursor: 'pointer',
    },
    '& .ant-timeline-item-tail': {
      top: '17px',
      left: '10px',
      borderLeft: '2px solid #DDD',
    },
    '& .ant-timeline-item-head-custom': {
      backgroundColor: 'transparent !important',
      top: '13px',
      left: '12px',
    },
    '& .ant-list-item': {
      paddingTop: '8px !important',
      paddingBottom: '11px !important',
    },
    paddingBottom: '0px',
  },
  timeLineHide: {
    '&:hover': {
      backgroundColor: '#f0f0f0 !important',
      cursor: 'pointer',
    },
    '& .ant-timeline-item-tail': {
      visibility: 'hidden',
    },
    '&  .ant-timeline-item-head-custom': {
      backgroundColor: 'transparent !important',
      top: '14px',
      left: '12px',
    },
    '& .ant-list-item': {
      paddingTop: '8px !important',
      paddingBottom: '4px !important',
    },
    paddingBottom: '0px',
  },
  notificationDivider: {
    marginTop: '6px',
    marginBottom: '6px',
  },
  moreNotification: {
    color: '#006EC3',
    fontWeight: 600,
    fontSize: '12px',
  },
  lessNotification: {
    color: '#006EC3',
    fontWeight: 600,
    fontSize: '12px',
    marginLeft: '28px',
    cursor: 'pointer',
  },
  markAllReadText: {
    color: '#006EC3',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  modalNotification: {
    '& .ant-modal-body': {
      padding: '12px',
    },
    marginTop: '-40px',
  },
  helpIcon: {
    fontSize: '21px',
    color: '#595959',
    margin: '0px 4px',
  },
  noAggreggateResultsContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  noAggregateWrapper: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '1rem',
    gap: '1rem',
    fontWeight: 600,
    alignItems: 'center',
  },
  unReadCountStyle: {
    '& .ant-badge-count': {
      right: '4px',
    },
  },
  userName: {
    color: '#666',
    textAlign: 'right',
    fontSize: '12px',
    fontWeight: 400,
  },
  notificationsText: {
    color: '#111',
    fontSize: '16px',
    fontWeight: '600',
  },
  popoverContent: {
    '& .ant-popover-inner-content': {
      padding: '10px 10px !important',
    },
  },
  notificationEndStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5px',
  },
  notificationEndText: {
    display: 'flex',
    flexDirection: 'column',
  },
  markAllReadStyle: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
  },
  avatarTextStyle: {
    fontSize: '10px',
    display: 'flex',
    alignItems: 'center',
  },
  test: {
    '& .ant-avatar-group': {
      paddingTop: '2px',
    },
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '28px',
    cursor: 'pointer',
    gap: '3px',
  },
});
